export default __webpack_public_path__ + "static/media/EsilioPic8.c4c2a3e1.png";